export default __webpack_public_path__ + "static/piercingdust-50e072813b4e70ed8d6898f99926d1c9.png";